export default {
    BASE_URL: '/admin/crm/mem/withdraw',
    api: [
      {
        name: 'list',
        desc: '列表',
        method: 'GET',
        path: '/list'
      },
      {
        name: 'handle',
        desc: '退会处理',
        method: 'PUT',
        path: '/handle'
      },
      {
        name: 'audit',
        desc: '退会审核',
        method: 'PUT',
        path: '/audit'
      }
    ]
  }
  


// WEBPACK FOOTER //
// ./src/api/member/quit.js